export default __webpack_public_path__ + "b818cee6e83854bec351e060b36d75fd.png";